import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgSpeedometerIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path d="M12 40.869h41.003V44H12zM33.557 27.61 42.137 19l2.137 2.236-8.58 8.614zm17.193 1.876H55v3.13h-4.25z" />
      <path d="M32.497 56A24.5 24.5 0 1 1 57 31.5 24.524 24.524 0 0 1 32.497 56m0-45.934A21.435 21.435 0 1 0 53.934 31.5a21.46 21.46 0 0 0-21.437-21.434" />
      <path d="M32.298 36.094a5.33 5.33 0 0 1-2.967-.902 5.366 5.366 0 0 1-.81-8.236 5.34 5.34 0 0 1 5.82-1.161 5.34 5.34 0 0 1 2.397 1.971 5.364 5.364 0 0 1-.666 6.758 5.34 5.34 0 0 1-3.774 1.57m0-7.654a2.285 2.285 0 0 0-2.114 1.416 2.3 2.3 0 0 0 .495 2.5 2.287 2.287 0 0 0 3.907-1.619 2.3 2.3 0 0 0-.67-1.62 2.3 2.3 0 0 0-1.618-.674zM30.772 9h3.052v3.616h-3.052zm-4.491 36.941H38.44V49H26.28zM43.78 16.617l3.084-3.028L49 15.779l-3.088 3.025zM10 29.208h3.6v3.06H10zm5.459-13.224 2.187-2.132 2.838 2.933-2.185 2.13z" />
    </g>
  </svg>
)
export default SvgSpeedometerIcon
